
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.125 13.578c.422.469.422 1.172 0 1.594-.469.469-1.172.469-1.594 0L8 9.594l-5.578 5.578c-.469.469-1.172.469-1.594 0-.469-.422-.469-1.125 0-1.594L6.406 8 .828 2.422C.36 1.953.36 1.25.828.828a1.027 1.027 0 011.547 0L8 6.453 13.578.875a1.027 1.027 0 011.547 0c.469.422.469 1.125 0 1.594L9.547 8l5.578 5.578z","fill":"currentColor"}})])
          )
        }
      }
    